import { render, staticRenderFns } from "./termofuse.vue?vue&type=template&id=1bf3f739&scoped=true"
import script from "./termofuse.vue?vue&type=script&lang=js"
export * from "./termofuse.vue?vue&type=script&lang=js"
import style0 from "./termofuse.vue?vue&type=style&index=0&id=1bf3f739&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf3f739",
  null
  
)

export default component.exports